import axios from 'axios';
import $ from 'jquery';
import { debounce, find } from 'lodash';
import React from 'react';
import { Button, Modal, } from 'react-bootstrap';
import ReactDOM from 'react-dom';
import { Link, } from 'react-router';
import '../../public/css/media/_checkout.scss';
import { areaWithDelay } from '../constants/areaWithDelay';
import { restrictedAreas } from '../constants/restrictedAreas';
import { history, } from '../store';
import CommonConstants from '../utils/CommonConstants';
import { adminUserIds, disabledCart, mapPrefixNumber, numbersWithComma } from '../utils/utils';
import AdvisoryModal from './AdvisoryModal';
import CheckoutBreakdown from './CheckoutBreakdown';
import DropdownIcon from './DashboardFiles/icons/angle-left.svg';
import CloudFlareBadge from './Layout/CloudFlareBadge';
import Footer from './Layout/Footer/Footer';
import OutBoundBanner from './OutBoundBanner';

const apiUrl = CommonConstants.Actions.api;

const createReactClass = require('create-react-class');
let addresses = [];

const INVALID_ADDRESS_ERROR = 'Please add/select a valid address.';

let cancelToken;

const Checkout = createReactClass({
    getInitialState() {
        return {
            payment_type: "adyen",
            air_address: "",
            sea_address: "",
            checkedPhp: true,
            checkedUsd: false,
            inputtedPromoCode: '',
            promo_code: "",
            first_name: false,
            last_name: false,
            street: false,
            country: false,
            province: false,
            city: false,
            district: false,
            postal: false,
            form_submitted: false,
            error: false,
            customErrorMessage: '',
            region: "",
            usd: true,
            php: false,
            terms: true,
            payship: false,
            air: false,
            sea: false,
            has_note: false,
            note_air: "",
            note_sea: "",
            note_submitted: false,
            country_value: "",
            province_value: "",
            city_value: "",
            postal_code_value: "",
            promo_success: "",
            promo_submitted: false,
            showModalAir: false,
            showModalSea: false,
            showAddAddress: false,
            withoutAddress: false,
            address_changed: false,
            showAirSubtotal: false,
            errors: {},
            addressState: '',
            selectedAirAddress: '',
            selectedSeaAddress: '',
            sameAddress: false,
            firstLoad: false,
            airAddresses: [],
            seaAddresses: [],
            airAddressesPagination: {
              currentPage: 1,
              lastPage: 1,
            },
            seaAddressesPagination: {
              currentPage: 1,
              lastPage: 1
            },
            addressSearchTermAir: '',
            addressSearchTermSea: '',
            debouncedSearch: debounce(this.handleGetAddress, 1000),
            isSearchLoading: false,
            hasSearchError: false,
            addAddressType: '',
            add_countryPrefix: '+63',
            address_phone_number: '',
            account_phone_number: '',
            notes: [],
            isSCProtectActive: true,
        };
    },
    close() {
        this.setState({
            showModalAir: false,
            showModalSea: false,
            showAddNoteAir: false,
            showAddNoteSea: false
            ,
            has_note: false,
            note_submitted: false,
            showAddAddress: false,
            air: false,
            sea: false,
            showAirSubtotal: false,
            showSeaSubtotal: false,
            alertModal: false,
        });
    },
    componentWillMount() {
        if (!localStorage.jwtToken) {
          history.push("/signin");
        } else if (!localStorage.item) {
          // history.push("/cart")
          window.location.replace(window.location.origin + "/cart");
        } else {
          const token = localStorage.jwtToken;
          var itemArry = JSON.parse(localStorage.item);
          var insurance = JSON.parse(localStorage.insurance);
          var shipment_location_details = JSON.parse(localStorage.shipment_location_details);
          var warehouse_id = JSON.parse(localStorage.warehouse_id);
          let sc_protect = {avail: this.state.isSCProtectActive ? 1 : 0};
          this.props.getCheckOut(token, itemArry, insurance, shipment_location_details, warehouse_id, sc_protect);
          this.props.getModalBlocks('checkout');

          const script = document.createElement("script");
          script.type = "text/javascript";
          script.src = "/js/custom.js";
          script.async = false;
          document.body.appendChild(script);
        }
        $('#SCTitle').text("Secure Checkout | ShippingCart");
      if (this.props.login && this.props.login.login.party && this.props.cart.shipment_location_details.destination !== 'MY'){
        const defaultAddress = this.props.login.login.party.addresses.find(address => address.id === this.props.login.login.party.address_id);
        if (this.findAddress(areaWithDelay, defaultAddress) && defaultAddress.country_code !== 'MY'){
          this.setState({ alertModal: true });
        }
      }
      this.props.getGlobalSettings(JSON.parse(localStorage.shipment_location_details).origin);
    },
    componentWillUnmount() {
      localStorage.removeItem('item');
      localStorage.removeItem('insurance');
      localStorage.removeItem('shipment_location_details');
      localStorage.removeItem('warehouse_id');
      localStorage.removeItem('airDangerous');
      localStorage.removeItem('seaDangerous');
      this.props.clearCheck();
    },
    componentDidUpdate() {

        var total_price = localStorage.total_price;
        if (this.props.customerCheckout.fetched_asiapay && total_price !== "0.00") {
            this.refs.asiapayform.click();
        }

        if (this.props.customerCheckout.fetched_adyen) {
            this.refs.adyenForm.click();
        }

      if (this.state.isSCProtectActive && this.props.customerCheckout.checkout.data && (this.props.customerCheckout.checkout.data.damage_items.total === this.props.customerCheckout.checkout.data.summary.usd.total_qty)) {
        this.setState({isSCProtectActive: false});
      }
      if (
        this.state.isSCProtectActive &&
        this.props.customerCheckout.checkout.data &&
        !this.props.customerCheckout.checkout.data.insurance_eligible &&
        this.props.customerCheckout.checkout.data.insurance_error &&
        this.props.customerCheckout.checkout.data.insurance_error
          .total_package_value
      ) {
        this.setState({ isSCProtectActive: false });
      }
    },
    componentWillReceiveProps(nextProps) {
      if (nextProps.login.fetched && nextProps.login.login.party){
        this.setState({account_phone_number: nextProps.login.login.party.phone_number})
        const admin = adminUserIds.find(id => id === nextProps.login.login.party.account_number)
        if(!admin && disabledCart){
          return history.push('/shipment')
        }
      }
        if (this.props.customerCheckout.fetched_computed !== nextProps.customerCheckout.fetched_computed) {
            this.setState({promo_success: nextProps.customerCheckout.fetched_computed,});

            if (this.refs.promo_code && this.refs.promo_code.value){
                const promo = nextProps.customerCheckout.checkout.data ? nextProps.customerCheckout.checkout.data.summary.usd.discount.code : null;
                this.setState({ promo_code: promo });
            }
        }
        else {
            this.setState({promo_success: nextProps.customerCheckout.fetched_computed,});
        }
        if (!this.state.address_changed) {
            if (this.props.login.fetched) {//to set the state of air_address and sea_address to default address and TO ENABLE TERMS CHECKBOX!
                let filtered_address = nextProps.login.login.party.addresses.filter(add => add.country_code === JSON.parse(localStorage.shipment_location_details).destination);
                if (nextProps.login.login.party.address_id != null) {
                  if(filtered_address.map(add => add.id).indexOf(nextProps.login.login.party.address_id) > -1) { // handle setting of air_address and sea_address states depending on destination country; 
                    this.setState({
                        address_changed: true,
                        air_address: nextProps.login.login.party.address_id,
                        sea_address: nextProps.login.login.party.address_id,
                    });
                  }
                }
            }
        }
        if (nextProps.login.addAddress) {
            ReactDOM.findDOMNode(this.refs.success_addAddress).focus();
            window.scrollTo(0, 0);
        }

        if ((nextProps.customerCheckout.error && nextProps.customerCheckout.error.response && nextProps.customerCheckout.error.response.status === 422)) {
          this.setState({ promo_code: "" });
        }

        if (nextProps.customerCheckout.checkout.data && nextProps.customerCheckout.checkout.data.summary.usd.total_price === 0) {
          this.setState({ promo_free_shipping: true });
        } else {
          this.setState({ promo_free_shipping: false });
        }
        
      const checkoutModalContent = nextProps.cms.getModal && nextProps.cms.modalContent && nextProps.cms.modalContent.data.variable === "Checkout-Modal" ? nextProps.cms.modalContent.data.status : false;
      this.setState({checkoutModalContent})

      if (!this.state.addressState) {
      const defaultAddress = this.props.login.login.party && this.props.login.login.party.addresses.filter(add => add.id === this.props.login.login.party.address_id).map(add => add.state)
        this.setState({ addressState: defaultAddress && defaultAddress[0]})
      }
      if (!this.state.selectedAirAddress && !this.state.selectedSeaAddress) {
        const defaultAddress = this.props.login.login.party && this.props.login.login.party.addresses.filter(add => add.id === this.props.login.login.party.address_id).map(add => add)
        if (defaultAddress && defaultAddress[0]) {
          if (defaultAddress[0].country_code === JSON.parse(localStorage.shipment_location_details).destination) {
            this.setState({ 
              selectedAirAddress: defaultAddress && defaultAddress[0],
              selectedSeaAddress: defaultAddress && defaultAddress[0]
             })
          }
        }
      }
      if (!this.state.firstLoad && nextProps.customerCheckout.checkout && nextProps.customerCheckout.checkout.data && (nextProps.customerCheckout.checkout.data.hasOwnProperty('air') && nextProps.customerCheckout.checkout.data.hasOwnProperty('sea'))) {
        const defaultAddress = nextProps.login.login.party && nextProps.login.login.party.addresses.filter(add => add.id === nextProps.login.login.party.address_id).map(add => add)
        if (defaultAddress.length >= 1 && defaultAddress[0].country_code === JSON.parse(localStorage.shipment_location_details).destination) {
          this.setState({
            selectedAirAddress: defaultAddress && defaultAddress[0],
            selectedSeaAddress: defaultAddress && defaultAddress[0],
            sameAddress: true,
            firstLoad: true
          })
        } else {
          this.setState({
            selectedAirAddress: '',
            selectedSeaAddress: '',
            firstLoad: true,
          })
        }
      }
    },
    componentDidMount() {
        window.scrollTo(0, 0);
        this.handleGetAddress('all', 1);
    },
    handleGetAddress(mode, page, searchTerm, isLoadMore) {
      if (typeof cancelToken !== typeof undefined) {
        cancelToken.cancel("Operation canceled due to new request.");
      }

      //Save the cancel token for the current request
      cancelToken = axios.CancelToken.source();
      const currentCountry = JSON.parse(localStorage.shipment_location_details)

      axios.get(`${apiUrl}user/addresses?page=${page}&search=${searchTerm || ''}&country_code=${currentCountry.destination}`).then((response) => {
        if (mode === 'air') {
          this.setState({
            airAddresses: isLoadMore ? [...this.state.airAddresses, ...response.data.data] : response.data.data,
            isSearchLoading: false,
            addressSearchTermAir:searchTerm,
            airAddressesPagination : {
              currentPage: response.data.current_page,
              lastPage: response.data.last_page
            }
          })
          return response
        }
        if (mode === 'sea') {
          this.setState({
            seaAddresses: isLoadMore ? [...this.state.airAddresses, ...response.data.data] : response.data.data,
            isSearchLoading: false,
            addressSearchTermSea:searchTerm,
            seaAddressesPagination : {
              currentPage: response.data.current_page,
              lastPage: response.data.last_page
            }
          })
          return response
        }
        this.setState({
          seaAddresses: response.data.data,
          airAddresses: response.data.data,
          airAddressesPagination : {
            currentPage: response.data.current_page,
            lastPage: response.data.last_page
          },
          seaAddressesPagination : {
            currentPage: response.data.current_page,
            lastPage: response.data.last_page
          },
          isSearchLoading: false
        })

        return response
    }).catch((err) => {
       console.log(err, 'err')
       return err
    })
    },
    handleSearchInputChange(e, type) {
      if (e.target.value === ' ' || e.target.value.split('').pop() === ' '){
        return
      }
      this.setState({isSearchLoading: true})
      this.state.debouncedSearch(type, 1, e.target.value);
    },
    handleLoadMoreAddresses(type) {
      if (type === 'air') {
        const currentPage = this.state.airAddressesPagination.currentPage + 1;
        this.handleGetAddress(type, currentPage, this.state.addressSearchTermAir, true)
        return
      }
      const currentPage = this.state.seaAddressesPagination.currentPage + 1;
      this.handleGetAddress(type, currentPage, this.state.addressSearchTermSea, true)

    },
    isLoadMoreShown(type) {
      if (type === 'air') {
        return this.state.airAddressesPagination.currentPage < this.state.airAddressesPagination.lastPage
      }
      return this.state.seaAddressesPagination.currentPage < this.state.seaAddressesPagination.lastPage
    },
    onPaymentChange(e) {
        this.setState({promo_submitted: false, promo_success: "", promo_code: ""});
        this.refs.promo_code.value = "";
        this.props.resetComputed();

        this.setState({payment_type: e.currentTarget.value,});

        const token = localStorage.jwtToken;
        var itemArry = JSON.parse(localStorage.item);
        var insurance = JSON.parse(localStorage.insurance);
        var shipment_location_details = JSON.parse(localStorage.shipment_location_details)
        var warehouse_id = JSON.parse(localStorage.warehouse_id)
        let sc_protect = { avail: this.state.isSCProtectActive ? 1 : 0 };
        this.props.getCheckOut(token, itemArry, insurance, shipment_location_details, warehouse_id, sc_protect);
    },
    onAirAddressChange(e, addresses) {
      this.setState({addressState: addresses.state})
      const isAddressWithDelay = this.findAddress(areaWithDelay, addresses);
      if (isAddressWithDelay) {
        this.setState({
          alertModal:true
        });
      }
        this.setState({promo_submitted: false, promo_success: "", promo_code: ""});
        this.refs.promo_code.value = "";
        this.props.resetComputed();

        if (this.state.sameAddress) {
          this.setState({
            selectedSeaAddress: addresses,
            sea_address: addresses.id
          })
        }

        const token = localStorage.jwtToken;
        var itemArry = JSON.parse(localStorage.item);
        var insurance = JSON.parse(localStorage.insurance);
        var shipment_location_details = JSON.parse(localStorage.shipment_location_details);
        var warehouse_id = JSON.parse(localStorage.warehouse_id);
        this.setState({address_changed: true,});
        this.setState({ selectedAirAddress: addresses})
        this.setState({air_address: addresses.id,}, () => {
          let sc_protect = { avail: this.state.isSCProtectActive ? 1 : 0 };
          this.props.getCheckOut(token, itemArry, insurance, shipment_location_details, warehouse_id, sc_protect, this.state.air_address, this.state.sea_address);
        });
    },
    onSeaAddressChange(e, addresses) {
      const isAddressWithDelay = this.findAddress(areaWithDelay, addresses);
      if (isAddressWithDelay) {
        this.setState({
          alertModal:true
        });
      }
        this.setState({promo_submitted: false, promo_success: "", promo_code: ""});
        this.refs.promo_code.value = "";
        this.props.resetComputed();

        const token = localStorage.jwtToken;
        var itemArry = JSON.parse(localStorage.item);
        var insurance = JSON.parse(localStorage.insurance);
        var shipment_location_details = JSON.parse(localStorage.shipment_location_details);
        var warehouse_id = JSON.parse(localStorage.warehouse_id);
        this.setState({address_changed: true,});
        this.setState({ selectedSeaAddress: addresses})
        this.setState({sea_address: addresses.id,}, () => {
          let sc_protect = { avail: this.state.isSCProtectActive ? 1 : 0 };
          this.props.getCheckOut(token, itemArry, insurance, shipment_location_details, warehouse_id, sc_protect, this.state.air_address, this.state.sea_address);
        });
    },
    handleSubmit(e) {
        e.preventDefault();
        this.setState({ payship:false, customErrorMessage: '', error: false });
        const token = localStorage.jwtToken;
        var itemArry = JSON.parse(localStorage.item);
        var insurance = JSON.parse(localStorage.insurance);
        var payment_type = this.state.payment_type;
        var air_address = this.state.air_address;
        var sea_address = this.state.sea_address;
        var note_air = this.state.note_air;
        var note_sea = this.state.note_sea;
        localStorage.setItem("note_air", note_air);
        localStorage.setItem("note_sea", note_sea);
        var total_price = this.props.customerCheckout.checkout.data ? this.props.customerCheckout.checkout.data.summary.usd.total_price : null;
        localStorage.setItem("total_price", total_price);
        var promo_code = this.state.promo_code;
        let is_dangerous_air = JSON.parse(localStorage.airDangerous).length > 0 ? 1 : 0;
        let is_dangerous_sea = JSON.parse(localStorage.seaDangerous).length > 0 ? 1 : 0;
        const isOffsizeCheckoutItem = this.props.customerCheckout.isOffsizeCheckout;
        const currentAirAddress = find(addresses, (address) => {
            // eslint-disable-next-line
            return address.id === Number(air_address) 
        })

        const currentSeaAddress = find(addresses, (address) => {
            // eslint-disable-next-line
            return address.id === Number(sea_address)
        })

        let sc_protect;
        const scProtectIds = this.props.customerCheckout.checkout.data && this.props.customerCheckout.checkout.data.insurance;
          sc_protect = {
            avail: this.state.isSCProtectActive ? 1 : 0,
            quotes_id: scProtectIds.quotes_id,
            submission_id: scProtectIds.submission_id,
            application_id: scProtectIds.application_id,
          };

        // const admin = adyenDropInAccount.find(id => id === this.props.login.login.party.account_number)
        if (this.state.payment_type === 'adyen') {
            if (!this.state.promo_free_shipping) {
                this.props.setCheckoutDetails(token, itemArry, air_address, sea_address, insurance, payment_type, note_air, note_sea, total_price, promo_code, JSON.parse(localStorage.shipment_location_details), JSON.parse(localStorage.warehouse_id),is_dangerous_air,is_dangerous_sea,sc_protect,isOffsizeCheckoutItem)
                history.push("/adyen-payment");
                return
            }
        }

        if (itemArry.air.length && !itemArry.sea.length) {
            if (currentAirAddress && currentAirAddress.isRestricted) {
                this.setState({error: true, terms: true, customErrorMessage: INVALID_ADDRESS_ERROR})
                return;
            }
            this.props.checkOutPayAirAndSea(token, itemArry, air_address, sea_address, insurance, payment_type, note_air, note_sea, total_price, promo_code, JSON.parse(localStorage.shipment_location_details), JSON.parse(localStorage.warehouse_id),is_dangerous_air,is_dangerous_sea,sc_protect,isOffsizeCheckoutItem);
        }
        else if (itemArry.sea.length && !itemArry.air.length) {
            if (currentSeaAddress && currentSeaAddress.isRestricted) {
                this.setState({error: true, terms: true, customErrorMessage: INVALID_ADDRESS_ERROR})
                return;
            }
            this.props.checkOutPayAirAndSea(token, itemArry, air_address, sea_address, insurance, payment_type, note_air, note_sea, total_price, promo_code, JSON.parse(localStorage.shipment_location_details), JSON.parse(localStorage.warehouse_id),is_dangerous_air,is_dangerous_sea,sc_protect,isOffsizeCheckoutItem);
        }
        else if (itemArry.air.length && itemArry.sea.length) {
            if ((currentSeaAddress && currentSeaAddress.isRestricted) || (currentAirAddress && currentAirAddress.isRestricted)) {
                this.setState({error: true, terms: true, customErrorMessage: INVALID_ADDRESS_ERROR})
                return;
            }
            this.props.checkOutPayAirAndSea(token, itemArry, air_address, sea_address, insurance, payment_type, note_air, note_sea, total_price, promo_code, JSON.parse(localStorage.shipment_location_details), JSON.parse(localStorage.warehouse_id),is_dangerous_air,is_dangerous_sea,sc_protect,isOffsizeCheckoutItem);
        }
    },
    handleCancelItemAir(id, e) {
        const token = localStorage.jwtToken;
        e.preventDefault();
        var itemArry = JSON.parse(localStorage.item);
        itemArry.air.splice(itemArry.air.indexOf(id), 1);
        if (itemArry.air.length === 0 && itemArry.sea.length === 0) {
            this.props.showEmptyItemOnCheckout();
            // window.location.replace(window.location.origin + "/cart");
            history.push("/cart");
        } else {
            localStorage.setItem("item", JSON.stringify(itemArry));
            var insurance = JSON.parse(localStorage.insurance);
            var shipment_location_details = JSON.parse(localStorage.shipment_location_details);
            var warehouse_id = JSON.parse(localStorage.warehouse_id);
            delete insurance[id];
            delete shipment_location_details[id];
            delete warehouse_id[id];
            localStorage.setItem("insurance", JSON.stringify(insurance));
            localStorage.setItem("shipment_location_details", JSON.stringify(localStorage.shipment_location_details));
            localStorage.setItem("warehouse_id", JSON.stringify(warehouse_id));
            let sc_protect = { avail: this.state.isSCProtectActive ? 1 : 0 };
            this.props.checkOut(token, itemArry, insurance, shipment_location_details, warehouse_id, sc_protect);
        }
    },
    handleCancelItemSea(id, e) {
        const token = localStorage.jwtToken;
        e.preventDefault();
        var itemArry = JSON.parse(localStorage.item);
        itemArry.sea.splice(itemArry.sea.indexOf(id), 1);
        if (itemArry.air.length === 0 && itemArry.sea.length === 0) {
            this.props.showEmptyItemOnCheckout();
            // window.location.replace(window.location.origin + "/cart");
            history.push("/cart");
        } else {
            localStorage.setItem("item", JSON.stringify(itemArry));
            var insurance = JSON.parse(localStorage.insurance);
            var shipment_location_details = JSON.parse(localStorage.shipment_location_details);
            var warehouse_id = JSON.parse(localStorage.warehouse_id);
            delete insurance[id];
            delete shipment_location_details[id];
            delete warehouse_id[id];
            localStorage.setItem("insurance", JSON.stringify(insurance));
            localStorage.setItem("shipment_location_details", JSON.stringify(localStorage.shipment_location_details));
            localStorage.setItem("warehouse_id", JSON.stringify(warehouse_id));
            let sc_protect = { avail: this.state.isSCProtectActive ? 1 : 0 };
            this.props.checkOut(token, itemArry, insurance, shipment_location_details, warehouse_id, sc_protect);
        }
    },
    handlePromo(e) {
        e.preventDefault();
        this.setState({promo_submitted: true, promo_success: ""});
        const token = localStorage.jwtToken;
        var itemArry = JSON.parse(localStorage.item);
        var air_address = this.state.air_address;
        var sea_address = this.state.sea_address;
        var insurance = JSON.parse(localStorage.insurance);
        var shipment_location_details = JSON.parse(localStorage.shipment_location_details);
        var warehouse_id = JSON.parse(localStorage.warehouse_id);
        var promo_code = this.state.inputtedPromoCode;
        this.setState({promo_code, promo_success : false});
        var payment_type = this.state.payment_type

        this.props.clearPromoError();

        if (itemArry.air.length && !itemArry.sea.length) {
            if (this.state.payment_type) {
                itemArry.air.address = air_address;

                if(promo_code){
                    let sc_protect = {
                      avail: this.state.isSCProtectActive ? 1 : 0,
                    };
                    this.props.checkOutPayAirAndSeaPromo(token, itemArry, insurance, promo_code, payment_type, shipment_location_details, warehouse_id, sc_protect);
                    this.setState({withoutAddress: false,});
                } else {
                    this.setState({ promo_success : false});
                }

            }
            else {
                this.setState({withoutAddress: true,});
            }
        }
        else if (itemArry.sea.length && !itemArry.air.length) {
            if (this.state.payment_type) {
                itemArry.sea.address = sea_address;

                if(promo_code){
                    let sc_protect = {
                      avail: this.state.isSCProtectActive ? 1 : 0,
                    };
                    this.props.checkOutPayAirAndSeaPromo(token, itemArry, insurance, promo_code, payment_type, shipment_location_details, warehouse_id, sc_protect);
                    this.setState({withoutAddress: false,});
                } else {
                    this.setState({ promo_success : false});
                }

            }
            else {
                this.setState({withoutAddress: true,});
            }
        }
        else if (itemArry.air.length && itemArry.sea.length) {
            if (this.state.payment_type) {
                itemArry.air.address = air_address;
                itemArry.sea.address = sea_address;

                if(promo_code){
                  let sc_protect = {
                    avail: this.state.isSCProtectActive ? 1 : 0,
                  };
                    this.props.checkOutPayAirAndSeaPromo(token, itemArry, insurance, promo_code, payment_type, shipment_location_details, warehouse_id, sc_protect);
                    this.setState({withoutAddress: false,});
                } else {
                    this.setState({ promo_success : false});
                }
            }
            else {
                this.setState({withoutAddress: true,});
            }
        }
    },
    inputChange(e){
      const target = e.target;
      const value = target.value;
      this.setState({inputtedPromoCode: value})
    },
    handleCountries(e, type) {
      e.preventDefault();
      this.setState({
        showAddAddress: true,
        form_submitted: false,
        error: false,
        country: true,
        addAddressType: type,
        country_name: JSON.parse(localStorage.shipment_location_details).destination
      }, () => {
          ReactDOM.findDOMNode(this.refs.first_name).focus();
          this.props.getProvinces(this.state.country_name);

        if(this.state.country_name === "PH") {
          this.props.getRegions();
        }
      });
      this.props.resetAccounts();
      this.setState({error: false, form_submitted: false,});
    },
    handleProvince(e) {
      this.refs.address_province.value = "";
      this.refs.address_city.value = "";
      this.refs.address_district.value = "";

      this.setState({
        country: true,
        country_name: e.target.value,
        province_value: "",
        city_value: "",
        district_value: "",
        postal_code_value: "",
        province: false,
        city: false,
        district: false
      }, () => {
        this.props.getProvinces(this.state.country_name);

        if(this.state.country_name === "PH") {
          this.props.getRegions();
        }
      })
    },
    handleCity(e) { //when province is changed, cities are populated
        var id = this.refs.address_province.value;
        var index = e.nativeEvent.target.selectedIndex;
        const parent_id = e.nativeEvent.target[index].getAttribute('data-parent-id');
        var name = e.nativeEvent.target[index].text;

        this.refs.address_city.value = this.refs.address_district.value = "";

        if (id === "") {
            this.setState({province: false, city: false, district: false,});
        }
        else {
            this.setState({province_value: name, province: true,});
        }

        if (this.props.login.region_fetched) {
            this.props.login.region.data.map((reg) => parseInt(parent_id, 10) === parseInt(reg.id, 10) ? this.setState({region: reg.name,}) : null)
        }
        this.props.getCities(id);
        this.setState({postal_code_value: "",});
    },

    handleDistrict(e) { //when city is changed, districts are populated
        var id = this.refs.address_city.value;
        var index = e.nativeEvent.target.selectedIndex;
        var city_name = e.nativeEvent.target[index].text;
        this.refs.address_district.value = "";

        if (id === "") {
            this.setState({city: false,});
        }
        else {
            this.setState({city_value: city_name, city: true,});
        }
        this.setState({postal_code_value: "",});
        this.props.getDistricts(id);
    },
    handleBarangay(e) {
        var index = e.nativeEvent.target.selectedIndex;
        var postal_code = e.nativeEvent.target[index].getAttribute('data-postal');
        this.setState({postal_code_value: postal_code, district: true, postal: true,});
    },
    handleInputChange(e) {
      const target = e.target;
      const name = target.name;
      const value = target.value;

      if(name === "add_countryPrefix"){
        this.setState({ [name]: value });
        this.setState({ phone_number: "" });
      }else {
        this.setState({ [name]: value });
      }
    },
    handleAddress() {
        this.setState({form_submitted: true,});
        const token = localStorage.jwtToken;
        var first_name = this.refs.first_name.value;
        var last_name = this.refs.last_name.value;
        var street = this.refs.street.value;
        var province = this.state.province_value;
        var city = this.state.city_value;
        var district = this.refs.address_district.value;
        var postal = this.refs.postal.value;
        var parameters = {
            token,
            "type": "delivery",
            "first_name": first_name,
            "middle_initial": "",
            "last_name": last_name,
            "line_1": street,
            "line_2": district,
            "city": city,
            "state": province,
            "postal_code": postal,
            "region": this.state.region,
            "country_code": this.state.country_name,
            "phone_number": this.state.add_countryPrefix && this.state.address_phone_number && `${this.state.add_countryPrefix}${this.state.address_phone_number}`
        }
        this.setState({error: false,}); //remove negative labels
        this.props.addAddress(parameters).then((res) => {
            if (res && res.response && res.response.data && res.response.data.errors) {
                const errors = {}
                res.response.data.errors.forEach(({title, detail}) =>{
                    errors[title]= detail;
                });

                this.setState({errors});
                return;
            }
            if (this.state.addAddressType === 'air') {
              if (!this.state.selectedAirAddress.id) {
                this.setState({selectedAirAddress: res.data})
              }
              if (!this.state.air_address) {
                this.setState({ air_address: this.state.selectedAirAddress.id })
              }
              this.setState({ airAddresses: [res.data, ...this.state.airAddresses]})
            } else {
              if (!this.state.selectedSeaAddress.id) {
                this.setState({selectedSeaAddress: res.data})
              }
              if (!this.state.sea_address) {
                this.setState({ sea_address: this.state.selectedSeaAddress.id })
              }
              this.setState({seaAddresses: [res.data, ...this.state.seaAddresses]})
            }

            this.setState({showAddAddress: false,});
        }); //add address
    },
    handleComputationOverview(type) {
      const { total_chargeable_weight: chargeable_weight, usd } = this.props.customerCheckout.checkout.data[type];
      const { per_pound_value, total_fixed_rate: fixed_fee } = usd;
      const { total_cargo, total_insurance: insurance_fee, total_storage_charge: storage_fee, total_price_before_discount, total_price_before_storage } = this.props.customerCheckout.checkout.data.original_computation[type].usd;

      if (type === "air") {
        this.setState({ showAirSubtotal: !this.state.showAirSubtotal, showSeaSubtotal: false }, !this.state.showAirSubtotal ? this.setState({breakdown: null}): null )
      } else if (type === "sea") {
        this.setState({ showSeaSubtotal: !this.state.showSeaSubtotal, showAirSubtotal: false })
      }

      this.setState({
        breakdown: {
          chargeable_weight,
          per_pound_value,
          fixed_fee,
          total_cargo,
          insurance_fee,
          storage_fee,
          total_price_before_discount,
          total_price_before_storage
        }
      })
    },
    handlePhp() {
        this.setState({php: true, usd: false,});
    },
    handleUsd() {
        this.setState({php: false, usd: true,});
    },
    handleCancel() {
        this.props.resetAccounts();
        this.setState({
            error: false,
            first_name: false,
            last_name: false,
            street: false,
            province: false,
            city: false,
            district: false,
            postal: false,
        });
    },
    handleNoteCancel() {
        this.setState({note_submitted: false, has_note: false,});
    },
    handleTerms(e) {
        e.target.checked ? this.setState({terms: false,}) : this.setState({terms: true,});
        this.state.terms && this.state.air_address && this.state.sea_address && this.state.payment_type ? this.setState({payship: true,}) : this.setState({payship: false,});
    },
    handleNoteAir(e) {
        e.preventDefault();
        this.setState({note_submitted: true,});
        this.setState({note_air: this.refs.note_air.value,});
        this.refs.note_air.value !== "" ? this.setState({showAddNoteAir: false, has_note: true,})
            : this.setState({has_note: false,});
    },
    handleNoteSea(e) {
        e.preventDefault();
        this.setState({note_submitted: true,});
        this.setState({note_sea: this.refs.note_sea.value,});
        this.refs.note_sea.value !== "" ? this.setState({showAddNoteSea: false, has_note: true,})
            : this.setState({has_note: false,});
    },
    handleAir(e) {
        e.preventDefault();
        this.setState({showAddNoteAir: true,});
    },
    handleSea(e) {
        e.preventDefault();
        this.setState({showAddNoteSea: true,});
    },
    handleLogout() {
        localStorage.removeItem('jwtToken');
        this.props.logout();
    },
    handleRemovePromo(e) {
        e.preventDefault();
        this.setState({promo_submitted: false, promo_success: false, promo_code: "", payment_type: "", terms: true, payship: false});
        this.props.resetComputed();
        if (this.refs.promo_code) {
            this.refs.promo_code.value = "";
        }
        const token = localStorage.jwtToken;
        var itemArry = JSON.parse(localStorage.item);
        var insurance = JSON.parse(localStorage.insurance);
        var shipment_location_details = JSON.parse(localStorage.shipment_location_details)
        var warehouse_id = JSON.parse(localStorage.warehouse_id)
        let sc_protect = { avail: this.state.isSCProtectActive ? 1 : 0 };
        this.props.checkOut(token, itemArry, insurance, shipment_location_details, warehouse_id, sc_protect);
    },
    handleOpenNoteAir(e) {
        e.preventDefault();
        this.setState({showModalAir: true,});
    },
    handleOpenNoteSea(e) {
        e.preventDefault();
        this.setState({showModalSea: true,});
    },
    saveNoteAir() {
        this.setState({showModalAir: false,});
        this.setState({note_air: this.refs.edit_note_air.value,});
    },
    saveNoteSea() {
        this.setState({showModalSea: false,});
        this.setState({note_sea: this.refs.edit_note_sea.value,});
    },
    handleRemoveNoteAir() {
        this.setState({note_air: "",});
    },
    handleRemoveNoteSea() {
        this.setState({note_sea: "",});
    },
    handleError() {
      return (
          this.props.login.fetched && this.props.customerCheckout.error && !this.state.promo_submitted ?
            <div className="sc-alert sc-alert-danger checkout-error">
              <i className="sc"/>{this.props.customerCheckout.error.response && this.props.customerCheckout.error.response.data.errors.detail}
            </div>
          : null
      )
    },
    handleCustomError() {
      return (
          this.state.error &&
            <div className="sc-alert sc-alert-danger checkout-error">
              <i className="sc"/>{this.state.customErrorMessage}
            </div>
      )
    },
    showTerms() {
        window.open('/terms-conditions', 'Terms and Conditions', 'width=1250,height=600')
    },
    checkoutModal() {
      return { __html: this.props.cms.getModal ? this.props.cms.modalContent.data.content.body : null, };
    },
    renderAirAddresses() {
        if (!this.props.customerCheckout.fetched) return;

        addresses = [...this.props.login.login.party.addresses];
        this.props.login.login.party.addresses.forEach((address) => {
        let isRestricted= false
        find(restrictedAreas.provinces, function(restrictedArea) {
            if (address.state === restrictedArea.province) {
            isRestricted = true
            }
        })
        if (!isRestricted) {
            find(restrictedAreas.cities, function(restrictedArea) {
            if (address.state === restrictedArea.province && address.city === restrictedArea.city ) {
            isRestricted = true
            }
        })
        }
        if (!isRestricted) {
            find(restrictedAreas.brgys, function(restrictedArea) {
            if (address.state === restrictedArea.province && address.city === restrictedArea.city && address.line_2 === restrictedArea.brgy ) {
            isRestricted = true
            }
        })
        }
        if (isRestricted) {
            address.isRestricted = true;
        }
        })

        return this.props.customerCheckout.checkout.data &&
        this.props.customerCheckout.checkout.data.hasOwnProperty("air") &&
          this.props.login.fetched &&
          <li className="dropdown" style={{ marginBottom: '20px', minHeight: '58px', listStyle: 'none', padding: '7px', border: '1px solid #E2E2E2', background: '#FCFCFC', borderRadius: '5px' }}>
            <span className="dropdown-toggle" data-toggle="dropdown" style={{ font: 'normal normal 600 14px/18px Source Sans Pro', width: '100%', display: 'inline-flex', alignItems: 'center' }}>
              {this.state.selectedAirAddress ? (<div style={{ padding: '0px 10px', width: '100%' }}><label htmlFor={this.state.selectedAirAddress.id} className="css-label">
                {(this.state.selectedAirAddress.full_name || JSON.parse(this.state.selectedAirAddress.name)).first_name} {(this.state.selectedAirAddress.full_name || JSON.parse(this.state.selectedAirAddress.name)).last_name}
                </label>
                <p className="address" style={{ margin: '10px 0px',fontWeight: 500, color: '#707070' }}>
                  {this.state.selectedAirAddress.line_1}, {this.state.selectedAirAddress.line_2}, {this.state.selectedAirAddress.city}, {this.state.selectedAirAddress.state}, {this.state.selectedAirAddress.postal_code}
                </p>
                <p style={{fontWeight: 500, color: '#707070', margin: '10px 0px',  }}>{this.state.selectedAirAddress.phone_number || this.props.login.login.party.phone_number}
                </p>
                </div>) : (<div style={{ padding: '11px 5px', marginRight: '20px', width: '100%' }}>Select Shipping Address</div>)}<i className="fa fa-angle-down" style={{float: 'right',fontSize: '23px'}}/>
            </span>
            <div className="sub sub-info dropdown-menu">
              <div style={{ margin: '0px 20px' }}>
                <input type="text" className="search-address" placeholder="Search address" onChange={(e) => { this.handleSearchInputChange(e, 'air') }} />
                <span style={{ position: 'absolute', top: '25px', right: '30px', backgroundColor: '#fff' }}><i className="fa fa-search"></i></span>
              </div>
              <ul style={{ padding: '0px 20px 20px 20px', maxHeight: '400px', overflow: 'auto', width: '100%' }}>
              
              {!this.state.isSearchLoading && this.state.airAddresses ? this.state.airAddresses.map((add, i) =>
                <li id={add.id} onClick={e => this.onAirAddressChange(e, add)}>
                  <label htmlFor={add.id} className="css-label">
                    {(add.full_name || JSON.parse(add.name)).first_name} {(add.full_name || JSON.parse(add.name)).last_name}
                  </label>
                  <p className="address">
                    {add.line_1}, {add.line_2}, {add.city}, {add.state}, {add.postal_code}
                  </p>
                  <p>{add.phone_number || this.props.login.login.party.phone_number}</p>
                </li>
                ):<div style={{ display: 'flex', justifyContent: 'center' }}>
                <div className="loader">
                  <i className="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
              }
              {
                !this.state.isSearchLoading && this.isLoadMoreShown('air') && 
                <form style={{
                  textAlign: 'center',
                  fontWeight: 600,
                  cursor: 'pointer',
                  color: '#0375d9'
                }}>
                  <p type="button" onClick={() => {
                  this.handleLoadMoreAddresses('air')
                }}>LOAD MORE</p>
                </form>
              }
              {
                !this.state.isSearchLoading && this.state.airAddresses && !this.state.airAddresses.length && 
                <p style={{ fontWeight: 600, textAlign:'center' }}>No Addresses Available</p>
              }
              </ul>
            </div>
          </li>
    },
    renderSeaAddresses() {
        if (!this.props.customerCheckout.fetched) return;

        addresses = [...this.props.login.login.party.addresses];

        this.props.login.login.party.addresses.forEach((address) => {
        let isRestricted= false
        find(restrictedAreas.provinces, function(restrictedArea) {
            if (address.state === restrictedArea.province) {
            isRestricted = true
            }
        })
        if (!isRestricted) {
            find(restrictedAreas.cities, function(restrictedArea) {
            if (address.state === restrictedArea.province && address.city === restrictedArea.city ) {
            isRestricted = true
            }
        })
        }
        if (!isRestricted) {
            find(restrictedAreas.brgys, function(restrictedArea) {
            if (address.state === restrictedArea.province && address.city === restrictedArea.city && address.line_2 === restrictedArea.brgy ) {
            isRestricted = true
            }
        })
        }
        if (isRestricted) {
            address.isRestricted = true;
        }
        })

        return this.props.customerCheckout.checkout.data &&
        this.props.customerCheckout.checkout.data.hasOwnProperty("sea") &&
        this.props.login.fetched &&
          (this.state.selectedSeaAddress && this.state.sameAddress ?
          <li style={{ marginBottom: '20px', minHeight: '58px', listStyle: 'none', padding: '7px', border: '1px solid #E2E2E2', background: '#F0F0F0', borderRadius: '5px', cursor: 'not-allowed' }}>
            <span style={{ font: 'normal normal 600 14px/18px Source Sans Pro', width: '100%', display: 'inline-flex', alignItems: 'center' }}>
              <div style={{ padding: '0px 10px', width: '100%' }}>
                <label htmlFor={this.state.selectedSeaAddress.id} className="css-label">
                  {(this.state.selectedSeaAddress.full_name || JSON.parse(this.state.selectedSeaAddress.name)).first_name} {(this.state.selectedSeaAddress.full_name || JSON.parse(this.state.selectedSeaAddress.name)).last_name}
                </label>
                <p className="address" style={{ marginBottom: '0px', font: 'normal normal normal 14px / 18px Source Sans Pro' }}>
                  {this.state.selectedSeaAddress.line_1} {this.state.selectedSeaAddress.line_2} {this.state.selectedSeaAddress.city} {this.state.selectedSeaAddress.state} {this.state.selectedSeaAddress.postal_code}
                </p>
                <p style={{fontWeight: 500, color: '#707070', margin: '10px 0px',  }}>{this.state.selectedSeaAddress.phone_number || this.props.login.login.party.phone_number}
                </p>
              </div><i className="fa fa-angle-down" style={{ float: 'right', fontSize: '23px' }} />
            </span>
          </li>
          :
          <li className="dropdown" style={{ marginBottom: '20px', minHeight: '58px', listStyle: 'none', padding: '7px', border: '1px solid #E2E2E2', background: '#FCFCFC', borderRadius: '5px' }}>
            <span className="dropdown-toggle" data-toggle="dropdown" style={{ font: 'normal normal 600 14px/18px Source Sans Pro', width: '100%', display: 'inline-flex', alignItems: 'center' }}>
              {this.state.selectedSeaAddress ? (<div style={{ padding: '0px 10px', width: '100%' }}><label htmlFor={this.state.selectedSeaAddress.id} className="css-label">
                {(this.state.selectedSeaAddress.full_name || JSON.parse(this.state.selectedSeaAddress.name)).first_name} {(this.state.selectedSeaAddress.full_name || JSON.parse(this.state.selectedSeaAddress.name)).last_name}
              </label>
                <p className="address" style={{ marginBottom: '0px', font: 'normal normal normal 14px / 18px Source Sans Pro', color: '#707070' }}>
                  {this.state.selectedSeaAddress.line_1}, {this.state.selectedSeaAddress.line_2}, {this.state.selectedSeaAddress.city}, {this.state.selectedSeaAddress.state}, {this.state.selectedSeaAddress.postal_code}
                </p>
                <p style={{fontWeight: 500, color: '#707070', margin: '10px 0px',  }}>{this.state.selectedSeaAddress.phone_number || this.props.login.login.party.phone_number}
                </p>
                </div>) : (<div style={{ padding: '11px 5px', marginRight: '20px', width: '100%' }}>Select Shipping Address</div>)}<i className="fa fa-angle-down" style={{ float: 'right', fontSize: '23px' }} />
            </span>
            <div className="sub sub-info dropdown-menu">
              <div style={{ margin: '0px 20px' }}>
                <input type="text" className="search-address" placeholder="Search address" onChange={(e) => { this.handleSearchInputChange(e, 'sea') }} />
                <span style={{ position: 'absolute', top: '25px', right: '30px', backgroundColor: '#fff' }}><i className="fa fa-search"></i></span>
              </div>
              <ul style={{ padding: '0px 20px 20px 20px', maxHeight: '400px', overflow: 'auto', width: '100%' }}>
              
              {!this.state.isSearchLoading && this.state.seaAddresses ? this.state.seaAddresses.map((add, i) =>
                <li id={add.id} onClick={e => this.onSeaAddressChange(e, add)}>
                  <label htmlFor={add.id} className="css-label">
                    {(add.full_name || JSON.parse(add.name)).first_name} {(add.full_name || JSON.parse(add.name)).last_name}
                  </label>
                  <p className="address" style={{ marginBottom: 10 }}>
                    {add.line_1}, {add.line_2}, {add.city}, {add.state}, {add.postal_code}
                  </p>
                  <p>{add.phone_number || this.props.login.login.party.phone_number}</p>
                </li>
                ):<div style={{ display: 'flex', justifyContent: 'center' }}>
                <div className="loader">
                  <i className="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
              }
              {
                !this.state.isSearchLoading && this.isLoadMoreShown('sea') && 
                <form style={{
                  textAlign: 'center',
                  fontWeight: 600,
                  cursor: 'pointer',
                  color: '#0375d9'
                }}>
                  <p type="button" onClick={() => {
                  this.handleLoadMoreAddresses('sea')
                }}>LOAD MORE</p>
                </form>
              }
              {
                !this.state.isSearchLoading && this.state.seaAddresses && !this.state.seaAddresses.length && 
                <p style={{ fontWeight: 600, textAlign:'center' }}>No Addresses Available</p>
              }
              </ul>
            </div>
          </li>)
    },
    findAddress(addresses, addressToFind) {
      if (!addressToFind) return false;
      let isAddressFound = false;
      addresses.provinces.find(({ province }) => {
        if (province === addressToFind.state) {
          isAddressFound = true;
        }
        return '';
      });
    
      if (!isAddressFound) {
        addresses.cities.find(({ province, city }) => {
          if (province === addressToFind.state && city === addressToFind.city) {
            isAddressFound = true;
          }
          return '';
        });
      }
    
      if (!isAddressFound) {
        addresses.brgys.find(({ province, city, brgy }) => {
          if (
            province === addressToFind.state &&
            city === addressToFind.city &&
            brgy === addressToFind.line_2
          ) {
            isAddressFound = true;
          }
          return '';
        });
      }
    
      return isAddressFound;
    },
    handleSameAddress() {
      this.setState({sameAddress: !this.state.sameAddress}, () => {
        this.setState({
          selectedSeaAddress: this.state.selectedAirAddress,
          sea_address: this.state.air_address
        })
      })
    },
    isTermsDisabled() {
      if (this.state.payment_type !== '' && (!!this.state.selectedAirAddress || !!this.state.selectedSeaAddress)) return false
      return true
    },

    handleToggleSCProtect(isSCProtectActive) {
      const token = localStorage.jwtToken;
      const itemArry = JSON.parse(localStorage.item);
      const insurance = JSON.parse(localStorage.insurance);
      const shipment_location_details = JSON.parse(localStorage.shipment_location_details)
      const warehouse_id = JSON.parse(localStorage.warehouse_id)
      let sc_protect = { avail: isSCProtectActive ? 1 : 0 };
      if (this.state.promo_code) {
        this.props.checkOutPayAirAndSeaPromo(token, itemArry, insurance, this.state.promo_code, this.state.payment_type, shipment_location_details, warehouse_id, sc_protect);
      } else {
        this.props.getCheckOut(token, itemArry, insurance, shipment_location_details, warehouse_id, sc_protect);
      }
    },


    handleSwitchToggle() {
      this.setState({isSCProtectActive: !this.state.isSCProtectActive}, () => {
        this.handleToggleSCProtect(this.state.isSCProtectActive)
      })
    },

    render() {
      const outboundBanner = this.props.settings && this.props.settings.globalSettings && this.props.settings.globalSettings.data.filter(data => data.name === 'outbound_banner');
      const minChargableWeight = this.props.settings && this.props.settings.globalSettings && this.props.settings.globalSettings.data.filter(data => data.name === 'minimum_chargeable_weight')[0];
        return (
            <div className="home">
                
                {this.props.customerCheckout.sc_protect_updating && 
                <div style={{top: 0, right: 0, left: 0, bottom:0, position:'fixed', alignItems: 'center', background: 'rgba(0,0,0,0.6)',zIndex: '999999', justifyContent: 'center', display: 'flex'}}>
                  <div style={{color: '#FFF', }}>
                    <i className="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>}
                <Modal className="alert-modal-checkout" show={this.state.alertModal} onHide={this.close} autoFocus={true}>
                    <Modal.Header closeButton/>
                    <Modal.Body>
                      <p>Our partner encountered problems delivering to your area, please expect delays and multiple delivery attempts. Rest assured that our team will ensure safe delivery of your package.</p>
                    </Modal.Body>
                    <Modal.Footer style={{"textAlign": "center"}}>
                        <button className="alert-modal-btn btn" onClick={this.close}>OK GOT IT!</button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.showModalAir} onHide={this.close} autoFocus={true}>
                    <Modal.Header closeButton>
                        <Modal.Title>Edit note for Air Cargo</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <textarea className="form-control" rows="20" defaultValue={this.state.note_air}
                                  ref="edit_note_air"></textarea>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.saveNoteAir}>Save</Button>
                        <Button onClick={this.close}>Close</Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.showModalSea} onHide={this.close} autoFocus={true}>
                    <Modal.Header closeButton>
                        <Modal.Title>Edit note for Sea Cargo</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        <textarea className="form-control" rows="20" defaultValue={this.state.note_sea}
                                  ref="edit_note_sea"></textarea>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button className="btn btn-orange" onClick={this.saveNoteSea}>Save</Button>
                        &nbsp; &nbsp; &nbsp;<a onClick={this.close}>Cancel</a>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.showAddNoteAir} onHide={this.close} autoFocus={true}>
                    <Modal.Header closeButton>
                        <Modal.Title>Add note for Air Cargo</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.note_submitted && !this.state.has_note ?
                            <label className="input-error">Add a note for our Warehouse Team.</label> : null}
                        <textarea className="form-control" rows="20"
                                  style={this.state.note_submitted ? this.state.has_note ? null : {borderColor: 'red',} : null}
                                  ref="note_air"></textarea>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="submit" className="btn btn-orange" onClick={this.handleNoteAir}>Save Note</button>
                        &nbsp; &nbsp; &nbsp;<a onClick={this.close}>Cancel</a>
                    </Modal.Footer>
                </Modal>
                <Modal show={this.state.showAddNoteSea} onHide={this.close} autoFocus={true}>
                    <Modal.Header closeButton>
                        <Modal.Title>Add note for Sea Cargo</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.note_submitted && !this.state.has_note ?
                            <label className="input-error">Add a note for our Warehouse Team.</label> : null}
                        <textarea className="form-control" rows="20"
                                  style={this.state.note_submitted ? this.state.has_note ? null : {borderColor: 'red',} : null}
                                  ref="note_sea"></textarea>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button className="btn btn-orange" onClick={this.handleNoteSea}>Save</Button>
                        &nbsp; &nbsp; &nbsp;<a onClick={this.close}>Cancel</a>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.showAddAddress} onHide={this.close} autoFocus={true}>
                    <Modal.Header style={{ marginBottom: 0, paddingBottom: 0 }} closeButton>
                      <div style={{ display: 'flex', justifyContent: 'space-between'}}>
                        <p style={{ color: '#333333', fontWeight: 600, fontSize:20 }}>Add Address</p>
                        <p style={{ color: '#707070', fontSize: 12, marginTop: 5,}}>All fields are required.</p>
                      </div>
                    </Modal.Header>
                    <Modal.Body style={{ padding: 20, color: '#707070'}}>

                        <form id="address" data-do="add-address">
                            <section>
                                {Object.keys(this.state.errors).length ? <div className="notify">
                                    <div className="sc-alert sc-alert-danger checkout-error"><i className="sc"></i> Fill
                                        in all fields to add address.
                                    </div>
                                </div> : null}
                                <div className="control">
                                    <label className="checkout-form-label">First Name &nbsp;
                                        {this.state.errors.first_name &&
                                            <label className="input-error">
                                                { this.state.errors.first_name }
                                            </label>
                                        }
                                    </label>
                                    <input type="text" maxLength="20" className="checkout-form-control" ref="first_name"
                                           placeholder="Enter First Name" defaultValue=""/>
                                </div>
                                <div className="control">
                                    <label className="checkout-form-label">Last Name &nbsp;
                                    {this.state.errors.last_name &&
                                        <label className="input-error">
                                            { this.state.errors.last_name }
                                        </label>
                                    }
                                    </label>
                                    <input type="text" maxLength="20" className=" checkout-form-control" ref="last_name"
                                           placeholder="Enter Last Name" defaultValue=""/>
                                </div>
                                <div className="control">
                                    <label className="checkout-form-label">Street Address &nbsp;
                                        {this.state.errors.line_1 &&
                                            <label className="input-error">
                                                { this.state.errors.line_1 }
                                            </label>
                                        }
                                    </label>
                                    <input type="text" maxLength="255" className=" checkout-form-control" ref="street"
                                           placeholder="Enter Street Address" defaultValue=""/>
                                </div>
                                <div className="control">
                                  <label className="checkout-form-label">Country&nbsp;
                                    {this.state.errors.country &&
                                        <label className="input-error">
                                            { this.state.errors.country }
                                        </label>
                                    }
                                  </label>
                                  <select onChange={this.handleProvince}
                                        value={localStorage.shipment_location_details ? JSON.parse(localStorage.shipment_location_details).destination : null}
                                        className="checkout-form-control"
                                        name="country"
                                        ref="address_country"
                                        disabled>
                                    <option value="" selected="selected">--- Select Country ---</option>
                                    <option value="PH">Philippines</option>
                                    {/* <option value="MY">Malaysia</option> */}
                                  </select>
                                </div>
                                <div className="control">
                                    <label className="checkout-form-label">{this.state.country_name === "MY" ? "State/Province" : "Province"} &nbsp;
                                        {this.state.errors.state &&
                                            <label className="input-error">
                                                { this.state.errors.state }
                                            </label>
                                        }
                                    </label>
                                    <select className="checkout-form-control" name="address_province"
                                            onChange={this.handleCity}
                                            disabled={this.state.country ? "" : "disabled"}
                                            ref="address_province">
                                        <option value="" selected="selected">--- Select {this.state.country_name === "MY" ? "State/Province" : "Province"} ---</option>
                                        {this.props.login.province_fetched ? (this.props.login.provinces.data || this.props.login.provinces).map((prov, i) =>
                                            <option key={i} value={prov.id}
                                                    data-parent-id={prov.parent_id}>{prov.name}</option>) : null}
                                    </select>
                                    <div className="error-text">
                                    </div>
                                </div>
                                <div className="control">
                                    <label className="checkout-form-label">City &nbsp;
                                        {this.state.errors.city &&
                                            <label className="input-error">
                                                { this.state.errors.city }
                                            </label>
                                        }
                                    </label>
                                    <select className="checkout-form-control" name="address_province"
                                            onChange={this.handleDistrict}
                                            disabled={this.state.province ? "" : "disabled"} ref="address_city">
                                        <option value="" selected="selected">--- Select City ---</option>
                                        {this.props.login.city_fetched ? (this.props.login.cities.data || this.props.login.cities).map((city, i) =>
                                                <option key={i} value={city.id}>{city.name}</option>)
                                            : null}
                                    </select>
                                </div>
                                <div className="control">
                                    <label className="checkout-form-label">{ this.state.country_name === "MY" ? "District/Barangay" : "Barangay"} &nbsp;
                                    {this.state.errors.line_2 &&
                                        <label className="input-error">
                                            { this.state.errors.line_2 }
                                        </label>
                                    }
                                    </label>
                                    <select className="checkout-form-control" name="address_province"
                                            disabled={this.state.city ? "" : "disabled"} onChange={this.handleBarangay}
                                            ref="address_district">

                                        <option value="" selected="selected">--- Select { this.state.country_name === "MY" ? "District/Barangay" : "Barangay"} ---</option>
                                        {this.props.login.district_fetched ? (this.props.login.districts.data || this.props.login.districts).map((dist, i) =>
                                                <option key={i} value={dist.name}
                                                        data-postal={dist.postal_code}>{dist.name} { this.state.country_name === "MY" && `(${dist.postal_code})`}</option>)
                                            : null}
                                    </select>
                                </div>
                                <div className="control">
                                    <label className="checkout-form-label">Postal &nbsp;</label>

                                    <input type="text" className="checkout-form-control" ref="postal" disabled
                                           value={this.state.postal_code_value}/>

                                </div>
                                <div style={{ marginTop: 15 }}>
                                  <label className='checkout-form-label'>Contact Number </label>&nbsp;<label ref="errors_add_phone_number" className="disnone"></label><br/>
                                  <div style={{display:'flex'}}>
                                    <div>
                                      <select style={{ width: 75 }} value={this.state.add_countryPrefix} onChange={this.handleInputChange} name="add_countryPrefix" className="checkout-form-control" >
                                        <option value="">Prefix</option>
                                        {mapPrefixNumber.map(prefix =>
                                          <option value={prefix.value}>{prefix.label}</option>
                                        )}
                                      </select>
                                      <img src={DropdownIcon} alt='icon' className="account-dropdown-icon" style={{ left: 77 }}/>
                                    </div>
                                  <input type="text" style={{margin:'0px 0px 0px 20px', width: '100%'}} ref="phone_number" name="address_phone_number" maxLength="10" value={this.state.address_phone_number} onChange={this.handleInputChange} autoComplete="off" className="checkout-form-control" />
                                  </div>
                                </div>
                                {this.state.errors.phone_number &&
                                  <label className="input-error">
                                      { this.state.errors.phone_number }
                                  </label>
                                }
                            </section>
                        </form>

                    </Modal.Body>
                    <div className="checkout-modal-footer" style={{ marginTop: 15, margin: 20 }}>
                        <button className="checkout-add-address-button" onClick={this.handleAddress}>Add Address</button>
                        <a  style={{ color: '#707070', fontWeight: 600, fontSize: 14, display: 'flex', justifyContent: 'center', width: 200, alignItems: 'center'  }}  onClick={this.close}>CANCEL</a>
                    </div>
                </Modal>

                {this.props.customerCheckout.fetched_asiapay ?
                    <form style={{display: "none",}} method="post"
                          action={this.props.customerCheckout.asiapay.parameters.payments.url}>
                        <input type="hidden" name="merchantId"
                               value={this.props.customerCheckout.asiapay.parameters.payments.query.merchantId}/>
                        <input type="hidden" name="amount"
                               value={this.props.customerCheckout.asiapay.parameters.payments.query.amount}/>
                        <input type="hidden" name="orderRef"
                               value={this.props.customerCheckout.asiapay.parameters.payments.query.orderRef}/>
                        <input type="hidden" name="currCode"
                               value={this.props.customerCheckout.asiapay.parameters.payments.query.currCode}/>
                        <input type="hidden" name="mpsMode"
                               value={this.props.customerCheckout.asiapay.parameters.payments.query.mpsMode}/>
                        <input type="hidden" name="successUrl"
                               value={this.props.customerCheckout.asiapay.parameters.payments.query.successUrl}/>
                        <input type="hidden" name="failUrl"
                               value={this.props.customerCheckout.asiapay.parameters.payments.query.failUrl}/>
                        <input type="hidden" name="cancelUrl"
                               value={this.props.customerCheckout.asiapay.parameters.payments.query.cancelUrl}/>
                        <input type="hidden" name="payType"
                               value={this.props.customerCheckout.asiapay.parameters.payments.query.payType}/>
                        <input type="hidden" name="lang"
                               value={this.props.customerCheckout.asiapay.parameters.payments.query.lang}/>
                        <input type="hidden" name="payMethod"
                               value={this.props.customerCheckout.asiapay.parameters.payments.query.payMethod}/>
                        <input type="hidden" name="failRetry"
                               value={this.props.customerCheckout.asiapay.parameters.payments.query.failRetry}/>
                        <input type="hidden" name="secureHash"
                               value={this.props.customerCheckout.asiapay.parameters.payments.query.secureHash}/>
                        <input type="submit" name="submit" ref="asiapayform"/>
                    </form>

                    :
                    null
                }

                {this.props.customerCheckout.fetched_adyen ?
                    <form style={{display: "none",}} method="post"
                          action={this.props.customerCheckout.adyen.attributes.url}>
                        <input type="hidden" name="merchantReference"
                               value={this.props.customerCheckout.adyen.attributes.merchant_reference}/>
                        <input type="hidden" name="paymentAmount"
                               value={this.props.customerCheckout.adyen.attributes.payment_amount}/>
                        <input type="hidden" name="skinCode"
                               value={this.props.customerCheckout.adyen.attributes.skin_code}/>
                        <input type="hidden" name="currencyCode"
                               value={this.props.customerCheckout.adyen.attributes.currency_code}/>
                        <input type="hidden" name="merchantAccount"
                               value={this.props.customerCheckout.adyen.attributes.merchant_account}/>
                        <input type="hidden" name="merchantSig"
                               value={this.props.customerCheckout.adyen.attributes.merchant_signature}/>
                        <input type="hidden" name="sessionValidity"
                               value={this.props.customerCheckout.adyen.attributes.session_validity}/>
                        <input type="hidden" name="shipBeforeDate"
                               value={this.props.customerCheckout.adyen.attributes.ship_before_date}/>
                        <input type="hidden" name="recurringContract"
                               value='ONECLICK'/>
                        <input type="hidden" name="shopperEmail" 
                               value={this.props.customerCheckout.adyen.attributes.shopperEmail}/>
                        <input type="hidden" name="shopperReference"
                               value={this.props.customerCheckout.adyen.attributes.shopperReference}/>
                        <input type="submit" ref="adyenForm"/>
                    </form>
                    :
                    null
                }

                <header className="site-header header-minimal">
                    <div className="container">

                        <div className="logo">
                            <Link to="/home" className="clearfix">
                                <div className="main-img"></div>
                            </Link>
                        </div>
                        <nav className="top-nav">
                            <ul>
                                <li className="dropdown has-sub">
                                    <a className="dropdown-toggle"
                                       data-toggle="dropdown">Hello {this.props.login.fetched ? this.props.login.login.party.first_name : null}&nbsp;
                                        <i className="fa fa-angle-down"></i></a>
                                    <ul className="sub sub-account dropdown-menu " style={{top: '80px'}}>
                                        <li><Link to="/cart"> Cart </Link></li>
                                        <li><Link to="/shipment"> Shipments</Link></li>
                                        <li><Link to="/account"> Account </Link></li>
                                        {this.props.parcelInfo.getParcel ? null : this.props.parcelInfo.getProhibited ? this.props.parcelInfo.prohibited.data.length > 0 ?
                                            <li>
                                                <Link to="/prohibited">
                                                    Prohibited Items </Link>
                                            </li> : null : null}
                                        <li><Link to="/home" onClick={this.handleLogout}> Logout </Link></li>
                                    </ul>
                                </li>

                            </ul>
                        </nav>
                    </div>
                </header>
                <div className="body-wrapper">
                    <div className="checkout container">
                        <div className="checkout-top text-center">
                            <div className="checkout-progress">
                            </div>
                        </div>
                        <div className="checkout-wrapper clearfix">
                            <div className="back-link">
                                <Link to="/cart"> &#60; Back to Cart</Link>
                            </div>
                            <div className="padding-left-30">
                                <div ref="success_addAddress"
                                     className={this.props.login.addAddress ? "sc-alert sc-alert-success" : "disnone"}>
                                    <i className="sc"></i>You've successfully added a new address.
                                </div>
                            </div>
                            {this.handleError()}
                            {this.handleCustomError()}
                            <form onSubmit={this.handleSubmit} className="clearfix">
                                <div className="step-1">
                                    <h4>1. How do you want to pay?</h4>
                                    <div className="payment-list">

                                        <div className="credit-card radio">
                                            <input name="payment_method" id="credit_card" value="adyen"
                                              ref="credit-card" onChange={this.onPaymentChange}
                                              className="css-checkbox" data-do="show-payment-description"
                                              data-on="click" type="radio"
                                              checked={this.state.payment_type === "adyen"}
                                              disabled={this.state.promo_free_shipping}
                                            />
                                            <label htmlFor="credit_card" className="css-label">
                                              Credit, Debit or Prepaid Card <br/>
                                              <span className="icon icon-visa"/> 
                                              <span className="icon icon-master"/>
                                              <span className="icon icon-jcb"/> 
                                              <span className="icon icon-amex"/> 
                                              <span className="icon icon-union"/> 
                                            </label>
                                            <p className={this.state.payment_type === "adyen" && !this.state.promo_free_shipping ? "payment-desc" : "hide"}>
                                                You may pay using your Visa or MasterCard. Select Credit, Debit or Prepaid Card as your
                                                mode of payment. You will be asked to provide information. Fill in the
                                                necessary details and click "Submit." Provide your credit, debit or prepaid card
                                                information and proceed to check out.
                                            </p>
                                        </div>


                                        <div className="paypal radio">
                                            <input name="payment_method" id="paypal" value="paypal" ref="paypal"
                                              onChange={this.onPaymentChange} className="css-checkbox"
                                              data-do="show-payment-description" data-on="click" type="radio"
                                              checked={this.state.payment_type === "paypal"}
                                              disabled={this.state.promo_free_shipping}
                                            />
                                            <label htmlFor="paypal" className="css-label">
                                               PayPal <span className="icon icon-paypal"/> 
                                            </label>
                                            <p className={this.state.payment_type === "paypal" && !this.state.promo_free_shipping ? "payment-desc" : "hide"}>
                                                Create or Sign-in to your Paypal account and choose between two easy payment options: <br />
                                                <i>a) Pay with my Credit or Debit Card</i><br />
                                                <i>b) Pay with my Paypal Account</i> 
                                            </p>
                                        </div>

                                        {
                                          this.state.promo_free_shipping ?
                                            <div className="radio freeshipping">
                                              <input name="payment_method" id="freeshipping" value="free_shipping"
                                                    onChange={this.onPaymentChange}
                                                    className="css-checkbox" data-do="show-payment-description"
                                                    data-on="click" type="radio" checked />
                                              <label htmlFor="free_shipping" className="css-label">
                                                Free Shipping
                                              </label>
                                            </div>
                                          : null
                                        }

                                        {/* <div className="paypal radio">
                      <input name="payment_method" id="adyen" value="adyen" ref="adyen" onChange={this.onPaymentChange} className="css-checkbox" data-do="show-payment-description" data-on="click" type="radio" />
                      <label htmlFor="adyen" className="css-label">
                        <span className="icon"></span> Adyen
                      </label>
                      <p className="payment-desc hide adyen">
                        You may pay using your Visa or MasterCard. Select Credit Card as your mode of payment. You will be asked to provide information. Fill in the necessary details and click "Submit." Provide your credit card information and proceed to check out.
                      </p>
                    </div> */}

                                    </div>
                                    <CloudFlareBadge type="e"/>

                                </div>

                                <div className="step-2">
                                    <div className="address-wrapper">
                                        <h4>2. Select your shipping address</h4>
                                        <p style={{'margin': '-18px 0px 20px 0'}}>
                                          {/* dynamic Banner */}
                                          {this.props.settings && this.props.settings.globalSettings && 
                                            <div style={{margin: '10px 0px'}}>
                                              <OutBoundBanner outBoundBannerData={outboundBanner}/>
                                            </div>
                                          }
                                        </p>
                                        {this.props.customerCheckout.checkout.data && (this.props.customerCheckout.checkout.data.hasOwnProperty("air") && this.props.customerCheckout.checkout.data.hasOwnProperty("sea")) &&
                                        <div className="checkbox">
                                          <div className="same-address">
                                            <input id="same-address"
                                              onClick={this.handleSameAddress}
                                              type="checkbox"
                                              ref="terms"
                                              className="accept-terms"
                                              checked={this.state.sameAddress}
                                            />
                                            <label htmlFor="same-address">
                                              Use the same shipping address for Air and Sea cargo.
                                            </label>
                                          </div>
                                        </div>}
                                        <div className="air-cargo">
                                            {this.props.customerCheckout.fetched && this.props.login.fetched && this.props.customerCheckout.checkout.data ? this.props.customerCheckout.checkout.data.hasOwnProperty("air") ?
                                                <h5>
                                                    Air Cargo
                                                    <p className="estimated">Estimated Delivery Date:
                                                        &nbsp;<span
                                                            className="from">{this.props.customerCheckout.checkout.data.delivery.air}</span>
                                                    </p>
                                                </h5>
                                                : null : null}
                                            { this.renderAirAddresses() }
                                            {this.props.customerCheckout.fetched && this.props.customerCheckout.checkout.data ? this.props.customerCheckout.checkout.data.hasOwnProperty('air') ?
                                                <div>
                                                    <p className="text-center"><span>or</span></p>

                                                    <div className="address-and-note">
                                                        <a onClick={(e) => {this.handleCountries(e, 'air')}}
                                                           className="add-address btn btn-grey-gradient"
                                                           data-type="air-cargo">
                                                            + Add New Shipping Address
                                                        </a>

                                                        {this.state.note_air === "" ?
                                                            <a onClick={this.handleAir} className="add-note">
                                                                Add a note for Air Cargo
                                                            </a>
                                                            : null}

                                                        {this.state.note_air !== "" ?
                                                            <div className="note-air-wrap note-wrapper clearfix">

                                                                <div className="alert alert-warning">
                                                                    <a className="remove-air-note close"
                                                                       onClick={this.handleRemoveNoteAir}>×</a>
                                                                    <p><strong>Note:</strong> {this.state.note_air}</p>
                                                                    <div>
                                                                        <a className="edit-note"
                                                                           onClick={this.handleOpenNoteAir}>Edit</a>
                                                                    </div>
                                                                </div>
                                                            </div> : null}
                                                    </div>
                                                </div> : null : null}
                                        </div>
                                        <div className="sea-cargo">
                                            {this.props.customerCheckout.fetched && this.props.customerCheckout.checkout.data ? this.props.customerCheckout.checkout.data.hasOwnProperty("sea") ?
                                                <h5>
                                                    Sea Cargo
                                                    <p className="estimated">Estimated Delivery Date:
                                                        &nbsp;<span
                                                            className="from">{this.props.customerCheckout.checkout.data.delivery.sea}</span>
                                                    </p>
                                                </h5>
                                                : null : null}
                                            { this.renderSeaAddresses() }
                                            {/* {this.props.customerCheckout.fetched && this.props.customerCheckout.checkout.data ? this.props.customerCheckout.checkout.data.hasOwnProperty("sea") ? this.props.login.fetched ? this.props.login.login.party.addresses.map((add, i) =>
                                                    add.id !== this.props.login.login.party.address_id ?
                                                        <div className="address-list radio" key={i}>
                                                            <input name="address[address_sea]" id={"sea" + add.id}
                                                                   value={add.id} onChange={this.onSeaAddressChange}
                                                                   className="css-checkbox" data-do="address-update"
                                                                   data-on="click" type="radio"/>
                                                            <label htmlFor={"sea" + add.id} className="css-label">
                                                                {add.full_name.first_name} {add.full_name.last_name}
                                                            </label>
                                                            <p className="address">
                                                                {add.line_1}, {add.line_2}, {add.city}, {add.state},
                                                                Philippines, {add.postal_code}
                                                            </p>
                                                        </div> : null)
                                                :
                                                null : null : null
                                            } */}

                                            {this.props.customerCheckout.fetched && this.props.customerCheckout.checkout.data ? this.props.customerCheckout.checkout.data.hasOwnProperty('sea') ?
                                                <div>
                                                    <p className="text-center"><span>or</span></p>

                                                    <div className="address-and-note">
                                                        <a onClick={(e) => {
                                                          if (this.state.sameAddress) return
                                                          this.handleCountries(e,'sea')}}
                                                          className="add-address btn btn-grey-gradient"
                                                           data-type="sea-cargo" disabled={this.state.sameAddress}>
                                                            + Add New Shipping Address
                                                        </a>
                                                        {this.state.note_sea === "" ?
                                                            <a onClick={this.handleSea} className="add-note"
                                                               data-do="add-note" data-on="click" data-method="sea">
                                                                Add a note for Sea Cargo
                                                            </a>
                                                            : null
                                                        }
                                                        {this.state.note_sea !== "" ?
                                                            <div className="note-air-wrap note-wrapper clearfix">

                                                                <div className="alert alert-warning">
                                                                    <a className="remove-air-note close"
                                                                       onClick={this.handleRemoveNoteSea}>×</a>
                                                                    <p><strong>Note:</strong> {this.state.note_sea}</p>
                                                                    <div>
                                                                        <a className="edit-note"
                                                                           onClick={this.handleOpenNoteSea}>Edit</a>
                                                                    </div>
                                                                </div>
                                                            </div> : null}
                                                    </div>
                                                </div> : null : null
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="step-3">
                                    <div className="yellowbgch" style={{backgroundColor: '#FEF6E7'}}>
                                        <div className="head">
                                            <h4 className="pull-left">3. Review before paying</h4>
                                        </div>
                                        <div className="details clearfix">
                                              <div>
                                                {this.props.customerCheckout.fetched && <CheckoutBreakdown data={this.props.customerCheckout.checkout.data} handleSwitchToggle={this.handleSwitchToggle} isSCProtectActive={this.state.isSCProtectActive} minChargableWeight={minChargableWeight} />}
                                                <div className={
                                                      this.props.login.fetched ?
                                                        this.props.login.login.party.vip_settings.free_insurance === "1" &&
                                                        this.props.login.login.party.vip_settings.free_shipping_fee === "1" &&
                                                        this.props.login.login.party.vip_settings.free_storage_charge === "1" &&
                                                        this.props.login.login.party.vip_settings.free_tax === "1" ? "disnone" : "apply-discount"
                                                      : null}>

                                                        <div> 
                                                          <div style={{display: 'inline-flex', width: '100%', justifyContent: 'space-between', alignItems: 'center'}}>
                                                            { !(this.state.promo_submitted && this.props.customerCheckout.checkout.hasOwnProperty('data') && this.state.promo_success && Object.keys(this.props.customerCheckout.checkout.data.summary.usd.discount).length > 0) && <input type="text"
                                                                   value={this.state.promo_submitted ? this.state.inputtedPromoCode : null}
                                                                   style={{ width: '75%', height: 46, fontSize: 14 }}
                                                                   onChange={this.inputChange}
                                                                   className={this.state.promo_submitted && this.state.promo_success && this.props.customerCheckout.checkout.hasOwnProperty('data') ? Object.keys(this.props.customerCheckout.checkout.data.summary.usd.discount).length > 0 ? "promo-applied" : "promo-code" : "promo-code"}
                                                                   name="promo"
                                                                   placeholder="Enter promo code"
                                                                   disabled={this.state.promo_submitted && this.state.promo_success && this.props.customerCheckout.checkout.hasOwnProperty('data') ? Object.keys(this.props.customerCheckout.checkout.data.summary.usd.discount).length > 0 ? "disabled" : "" : null}
                                                                   data-on="keypress" defaultValue="" ref="promo_code"/>}

                                                            {this.state.promo_submitted ?
                                                                this.state.promo_success && this.props.customerCheckout.checkout.hasOwnProperty('data') ?
                                                                    Object.keys(this.props.customerCheckout.checkout.data.summary.usd.discount).length > 0
                                                                        ? null :
                                                                        <button type="button"
                                                                                className="promo-button"
                                                                                data-do="get-promo-code" data-on="click"
                                                                                style={{ marginLeft: 15 , background: 'none'}}
                                                                                onClick={this.handlePromo}>
                                                                            Apply</button> : <button type="button"
                                                                                                     className="promo-button"
                                                                                                     data-do="get-promo-code"
                                                                                                     data-on="click"
                                                                                                     onClick={this.handlePromo}>
                                                                        Apply</button> :
                                                                <button type="button" className="promo-button"
                                                                        data-do="get-promo-code" data-on="click"
                                                                        onClick={this.handlePromo}>Apply</button>}
                                                              </div>

                                                            {
                                                              this.state.promo_submitted && this.state.payment_type ?
                                                                !this.state.withoutAddress && this.props.customerCheckout.fetching_computed ?
                                                                  null
                                                                  : !this.state.promo_success && this.props.customerCheckout.error ?
                                                                    <div className="error-text" data-error="promo">
                                                                      { this.props.customerCheckout.error.response && this.props.customerCheckout.error.response.data.errors.detail.includes('invalid') ? 
                                                                        this.props.customerCheckout.error.response.data.errors.detail :
                                                                        this.props.customerCheckout.error.response.data.errors.detail.includes('Account is not allowed') ? "You're not authorized to use this code." :
                                                                        this.props.customerCheckout.error.response.data.errors.detail }
                                                                    </div>
                                                                    : null

                                                                : null
                                                            }

{
                                                              this.state.promo_submitted && this.state.payment_type ?
                                                                !this.state.withoutAddress && this.props.customerCheckout.fetching_computed ?
                                                                  null
                                                                  : !this.state.promo_success && !this.props.customerCheckout.error ?
                                                                    <div className="error-text" data-error="promo">
                                                                      {this.props.customerCheckout.error.response.data.errors.detail}                                                                      
                                                                    </div>
                                                                    : null

                                                                : null
                                                            }


                                                            {this.state.promo_submitted && this.state.withoutAddress && !this.state.payment_type ?
                                                                <div className="error-text" data-error="promo">Please
                                                                    select a payment type first.</div>
                                                                  : null }

                                                            {/*after clicking apply*/}
                                                            {this.state.promo_submitted && this.state.promo_success && this.props.customerCheckout.checkout.hasOwnProperty('data') ? Object.keys(this.props.customerCheckout.checkout.data.summary.usd.discount).length > 0 ? null
                                                                :
                                                                <div className="error-text"
                                                                     data-error="promo">{this.props.customerCheckout.checkout.data.discount_message}</div>
                                                                :
                                                                null
                                                            }
                                                        </div>


                                                        {
                                                            this.state.promo_submitted && this.props.customerCheckout.checkout.hasOwnProperty('data') && this.state.promo_success && Object.keys(this.props.customerCheckout.checkout.data.summary.usd.discount).length > 0 &&
                                                        <div className="discount-fee text-center">
                                                           <div>
                                                                <div className='flex-container'>
                                                                    <p className='font-16' style={{ color: '#707070' }}>Discount Code</p>
                                                                    <p className='font-16'>{this.state.promo_code}</p>
                                                                </div>
                                                                <div className='flex-container'>
                                                                    <p className='font-16' style={{ color: '#707070' }}>{`${this.props.customerCheckout.checkout.data.summary.usd.discount.label} Discount` }</p>
                                                                    <p className='font-16'>{`- USD ${numbersWithComma(Number(this.props.customerCheckout.checkout.data.summary.usd.total_discount).toFixed(2))}`}</p>
                                                                </div>
                                                                <div className='flex-container' style={{ justifyContent: 'flex-end' }}>
                                                                <div><a
                                                                    onClick={this.handleRemovePromo} style={{ fontSize: 16, fontWeight: 600 }}>Remove</a>
                                                                 </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        }
                                                    </div>

                                                  { this.props.settings && this.props.settings.notes && !!this.props.settings.notes.length && 
                                                    <div className="important-notes" style={{padding: '20px', border: '1px solid #0375D9', backgroundColor: '#FFF', margin: '10px 0px', borderRadius: '10px'}}>
                                                      <div style={{fontSize: '16px', fontWeight: 600, marginBottom: '10px'}}><span className='fa fa-info-circle' style={{color: '#0375D9', fontSize: 16, marginRight: '5px' }}/>Important Note:</div>
                                                      <ul>
                                                        {this.props.settings && this.props.settings.notes && this.props.settings.notes.map((note) => <li style={{listStyle: 'disc', marginLeft: '20px'}} dangerouslySetInnerHTML={{ __html: note }}></li>)}
                                                      </ul>
                                                    </div>
                                                  }

                                            <div className="terms-condition">
                                                <label>
                                                    <div className="checkbox">
                                                        <input id="accept-terms"
                                                               onClick={this.handleTerms}
                                                               type="checkbox"
                                                               ref="terms"
                                                               className="accept-terms"
                                                               disabled={this.isTermsDisabled()}/>
                                                        <label htmlFor="accept-terms">
                                                          {JSON.parse(localStorage.shipment_location_details).destination !== 'MY' ?                                                         
                                                            <div>Ticking this box means I agree & accept the updated ShippingCart <a onClick={this.showTerms} className="terms" style={{fontSize: '13px', textDecoration: 'none'}} target="_blank">Terms and
                                                              Conditions</a> together with the SC protect coverage.
                                                            </div> 
                                                            :
                                                            <div>Ticking this box and paying for my shipment means I have
                                                              read, understand, and agree to ShippingCart's updated
                                                              <a onClick={this.showTerms} className="terms" target="_blank">Terms and
                                                              Conditions</a>.
                                                            </div>
                                                          }
                                                        </label>
                                                    </div>
                                                </label>
                                            </div>
                                                  
                                                {this.props.customerCheckout.fetched && <div>
                                                  <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '20px', fontWeight: 600, color: '#323232', margin: '20px 0px'}}>
                                                    <span>Shipment Cost</span>
                                                    USD {this.props.customerCheckout.checkout.data && numbersWithComma(this.props.customerCheckout.checkout.data.summary.usd.total_price.toFixed(2))}
                                                  </div>
                                                </div>}
                                              </div>
                                            <input type="hidden" name="csrf" value="95d7f5f947530b4bd45dc37044bdfd94"/>
                                                <div className="pay-ship text-center" style={{margin: '25px 0px'}}>
                                                <button
                                                    className={this.state.terms ? "proceedToCheckoutButton btn-disabled" : "proceedToCheckoutButton"}
                                                    style={{padding: '5px', borderRadius: '100px', fontSize: '16px', fontWeight: 600}}
                                                    type="submit"
                                                    disabled={this.state.terms ? "disabled" : ""}>
                                                    PAY AND SHIP
                                                </button>
                                                <i className="payment-gateway-disclaimer" style={{fontSize: '10px'}}>Note: You will be redirected to our payment gateway after clicking Pay & Ship.</i>
                                              </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            <div className="back-link bottom">
                                <Link to="/cart"> &#60;  Back to Cart</Link>
                            </div>
                        </div>
                        <div className="bottom-shadow"></div>
                        {localStorage.checkoutModalShowed ? null :
                          this.state.checkoutModalContent ?
                            <AdvisoryModal show={this.props.cms.showAdvisoryModal['checkout']}
                              close={dispatch => this.props.closeModal('checkout')}
                              content={this.checkoutModal()}
                            />
                          : null
                        }
                    </div>
                </div>

                <Footer
                    currentPath={this.props.location.pathname}
                    currentYear={this.props.login.year}
                />

            </div>
        )
    },
});
export default Checkout;



/** WEBPACK FOOTER **
 ** ./src/components/Checkout.js
 **/